import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { ENDPOINTS } from "../../config/api";
import "bootstrap/dist/css/bootstrap.min.css";

const Dashboard = () => {
  const { authFetch, token } = useContext(AuthContext);
  const [lastPostulations, setLastPostulations] = useState([]);


  /* ======================
     ESTADOS
  ====================== */
  const [activeOffers, setActiveOffers] = useState(0);
  const [postulations, setPostulations] = useState(0);
  const [interviews, setInterviews] = useState(0);
  const [contracts, setContracts] = useState(0);
  /* ======================
     CARGAR MÉTRICAS
  ====================== */
  useEffect(() => {
    if (!token) return;

 const loadDashboardData = async () => {
  try {
    const [offersRes, postRes, interRes, contRes] = await Promise.all([
      authFetch(ENDPOINTS.getActiveOffers),
      authFetch(ENDPOINTS.GetPostulacion),
      authFetch(ENDPOINTS.getInterview),
      authFetch(ENDPOINTS.getContract),
    ]);

    /* ================= OFERTAS ================= */
    if (offersRes?.success && Array.isArray(offersRes.data)) {
      setActiveOffers(offersRes.data.length);
    }

    /* ================= POSTULACIONES ================= */
    if (postRes?.success && Array.isArray(postRes.data)) {
      setPostulations(postRes.data.length);

      setLastPostulations(
        postRes.data
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
          .slice(0, 3)
      );
    }

    /* ================= ENTREVISTAS ================= */
    if (interRes?.success && Array.isArray(interRes.data)) {
      setInterviews(interRes.data.length);
    } else {
      setInterviews(0);
    }

    /* ================= CONTRATOS ================= */
    if (contRes?.success && Array.isArray(contRes.data)) {
      setContracts(contRes.data.length);
    } else {
      setContracts(0);
    }

  } catch (error) {
    console.error("Error cargando dashboard:", error);
  }
};


    loadDashboardData();
  }, [token, authFetch]);

  return (
    <div className="container-fluid p-4 bg-light min-vh-100">

      {/* ================= HEADER ================= */}
      <div className="mb-4">
        <h2 className="fw-bold">Dashboard – Recursos Humanos</h2>
        <p className="text-muted">
          Vista general del sistema de gestión de talento humano
        </p>
      </div>

      {/* ================= METRIC CARDS ================= */}
      <div className="row g-4 mb-4">
        <DashboardCard
          title="Ofertas Activas"
          value={activeOffers}
          color="primary"
        />

        <DashboardCard
          title="Postulaciones"
          value={postulations}
          color="success"
        />

        <DashboardCard
          title="Entrevistas"
          value={interviews}
          color="warning"
        />


        <DashboardCard
          title="Contratos Activos"
          value={contracts}
          color="dark"
        />
      </div>

      {/* ================= ACTIONS ================= */}
      <div className="row mb-4">
        <div className="col-lg-6 mb-3">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <h5 className="card-title">Acciones rápidas</h5>
              <div className="d-flex flex-wrap gap-2">
                <button className="btn btn-outline-primary">Nueva oferta</button>
                <button className="btn btn-outline-success">Registrar postulante</button>
                <button className="btn btn-outline-warning">Realizar entrevista</button>
                <button className="btn btn-outline-dark">Hoja de vida</button>
              </div>
            </div>
          </div>
        </div>

        {/* ================= STATUS ================= */}
        <div className="col-lg-6 mb-3">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <h5 className="card-title">Estado del proceso</h5>
              <ul className="list-group list-group-flush">
                <li className="list-group-item d-flex justify-content-between">
                  Exámenes ocupacionales <span className="badge bg-primary">—</span>
                </li>
                <li className="list-group-item d-flex justify-content-between">
                  Contratos por firmar <span className="badge bg-warning">—</span>
                </li>
                <li className="list-group-item d-flex justify-content-between">
                  Hojas de vida recibidas <span className="badge bg-success">—</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* ================= TABLE ================= */}
      <div className="card shadow-sm">
        <div className="card-body">
          <h5 className="card-title mb-3">Últimas postulaciones</h5>

          <div className="table-responsive">
            <table className="table table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th>Nombre</th>
                  <th>Cargo</th>
                  <th>Estado</th>
                  <th>Fecha</th>
                </tr>
              </thead>
              <tbody>
                  {lastPostulations.length > 0 ? (
                    lastPostulations.map((p) => (
                      <tr key={p.IdPostulacion}>
                        <td>
                          {p.user_name} {p.user_last_name}
                        </td>

                        <td>
                          {p.nombreOferta || "-"}
                        </td>

                        <td>
                          <span
                            className={`badge ${
                              p.state === "Aceptado"
                                ? "bg-success"
                                : p.state === "Denegado"
                                ? "bg-danger"
                                : "bg-warning text-dark"
                            }`}
                          >
                            {p.state}
                          </span>
                        </td>

                        <td>
                          {new Date(p.created_at).toLocaleDateString("es-CO")}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center text-muted">
                        No hay postulaciones registradas
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>
  );
};

/* ================= CARD COMPONENT ================= */
const DashboardCard = ({ title, value, color }) => (
  <div className="col-md-6 col-lg-3">
    <div className={`card text-white bg-${color} shadow-sm h-100`}>
      <div className="card-body">
        <h6 className="card-title">{title}</h6>
        <h2 className="fw-bold">{value}</h2>
      </div>
    </div>
  </div>
);

export default Dashboard;
